import * as React from 'react';
export var Icon = function (props) {
    return (React.createElement("span", { style: { textRendering: 'geometricPrecision' }, className: 'icon icon-' + props.icon + (props.className ? ' ' + props.className : '') }));
};
//# sourceMappingURL=index.js.map